"use client";
import React from "react";

export const RootLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      id="rootLayout"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        minWidth: "1200px",
        overflow: "hidden",
      }}
    >
      {children}
    </div>
  );
};
